import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import { ScrollArea } from "../components/ui/scroll-area";

export default function Education() {
  const [content, setContent] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const res = await axios.get(`${API}/education`);
      setContent(res.data);
      if (res.data.length > 0) {
        setSelectedItem(res.data[0]);
      }
    } catch (err) {
      console.error("Failed to fetch education content:", err);
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (iconName) => {
    const icons = {
      target: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      ),
      droplets: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      flame: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
        </svg>
      ),
      "trending-up": (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
      shield: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      "check-square": (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      ),
      brain: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      "git-merge": (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
        </svg>
      ),
    };
    return icons[iconName] || icons.target;
  };

  const formatContent = (text) => {
    const lines = text.split('\n');
    return lines.map((line, i) => {
      if (line.startsWith('**') && line.includes('**')) {
        const parts = line.split('**');
        return (
          <p key={i} className="font-bold text-white my-3 text-lg">
            {parts.filter((_, idx) => idx % 2 === 1).join('')}
          </p>
        );
      }
      if (line.startsWith('- ')) {
        return (
          <div key={i} className="flex items-start gap-2 my-1 ml-2">
            <div className="w-1.5 h-1.5 bg-blue-500 mt-2 flex-shrink-0" />
            <span className="text-slate-300">{line.slice(2)}</span>
          </div>
        );
      }
      if (line.match(/^\d+\./)) {
        return (
          <div key={i} className="flex items-start gap-3 my-2 ml-2">
            <span className="font-mono text-blue-500 font-bold">{line.match(/^\d+/)[0]}.</span>
            <span className="text-slate-300">{line.replace(/^\d+\.\s*/, '')}</span>
          </div>
        );
      }
      if (line.trim() === '') {
        return <div key={i} className="h-2" />;
      }
      return <p key={i} className="text-slate-400 my-1">{line}</p>;
    });
  };

  const categories = [...new Set(content.map(c => c.category))];

  return (
    <div className="h-screen flex" data-testid="education-page">
      {/* Sidebar */}
      <div className="w-80 border-r border-[#262626] flex flex-col bg-[#050505]">
        <div className="p-6 border-b border-[#262626]">
          <h1 className="text-xl font-mono font-bold text-white">PLAYBOOK</h1>
          <p className="text-xs text-slate-500 font-mono mt-1">Master the institutional edge</p>
        </div>
        
        <ScrollArea className="flex-1">
          <div className="p-4 space-y-6">
            {categories.map((category) => (
              <div key={category}>
                <h3 className="text-xs font-mono text-slate-600 uppercase tracking-wider mb-2 px-2">
                  {category}
                </h3>
                <div className="space-y-1">
                  {content
                    .filter((c) => c.category === category)
                    .map((item) => (
                      <button
                        key={item.id}
                        onClick={() => setSelectedItem(item)}
                        data-testid={`education-item-${item.id}`}
                        className={`w-full flex items-center gap-3 px-3 py-3 text-left transition-colors ${
                          selectedItem?.id === item.id
                            ? "bg-[#171717] border-l-2 border-blue-500 text-white"
                            : "text-slate-400 hover:bg-[#0A0A0A] hover:text-white border-l-2 border-transparent"
                        }`}
                      >
                        <div className={`p-1.5 border ${
                          selectedItem?.id === item.id 
                            ? "border-blue-500/50 text-blue-500" 
                            : "border-[#262626] text-slate-500"
                        }`}>
                          {getIcon(item.icon)}
                        </div>
                        <span className="text-sm font-mono">{item.title}</span>
                      </button>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </div>

      {/* Content Area */}
      <div className="flex-1 flex flex-col bg-[#050505]">
        {selectedItem ? (
          <>
            {/* Header */}
            <div className="p-6 border-b border-[#262626]">
              <div className="flex items-center gap-4">
                <div className="p-3 border border-blue-500/30 bg-blue-500/10 text-blue-500">
                  {getIcon(selectedItem.icon)}
                </div>
                <div>
                  <h2 className="text-2xl font-mono font-bold text-white">{selectedItem.title}</h2>
                  <p className="text-sm text-slate-500 font-mono">{selectedItem.category}</p>
                </div>
              </div>
            </div>

            {/* Content */}
            <ScrollArea className="flex-1 p-6">
              <div className="max-w-3xl">
                <div className="card-institutional p-6">
                  <div className="prose prose-invert max-w-none">
                    {formatContent(selectedItem.content)}
                  </div>
                </div>

                {/* Key Takeaway */}
                <div className="mt-6 p-4 border border-yellow-500/30 bg-yellow-500/5">
                  <div className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p className="font-mono text-sm text-yellow-500 font-bold mb-1">KEY TAKEAWAY</p>
                      <p className="text-sm text-slate-400">
                        Understanding this concept is crucial for aligning with institutional order flow. 
                        Practice identifying these patterns on historical charts before risking capital.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Practice Note */}
                <div className="mt-4 p-4 border border-[#262626]">
                  <p className="text-xs font-mono text-slate-500">
                    <span className="text-blue-500">TIP:</span> Use the AI Coach to discuss this concept 
                    and get personalized guidance on how to apply it to your trading.
                  </p>
                </div>
              </div>
            </ScrollArea>
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <p className="text-slate-500 font-mono">Select a topic to begin learning</p>
          </div>
        )}
      </div>
    </div>
  );
}
